// Mini-Badge für Listen — zeigt Beistelteil-Status pro Auftrag
// z.B. "📦 2/5"  (5 Beistelteil, 2 eingegangen) oder "📦 ⚠" für überfällig
import { Package } from 'lucide-react';
import type { BeistelteilSummary } from '../lib/api';

export default function BeistelteileIndicator({ summary }: { summary: BeistelteilSummary | undefined }) {
  if (!summary || summary.total === 0) return null;

  const eingang = summary.eingegangen + summary.verbaut + summary.versendet;
  const total = summary.total;
  const isUeberfaellig = summary.ueberfaellig > 0;
  const isComplete = eingang === total;

  let cls = 'bg-slate-100 text-slate-700';
  if (isUeberfaellig) cls = 'bg-red-100 text-red-800 ring-1 ring-red-300';
  else if (isComplete) cls = 'bg-emerald-100 text-emerald-800';
  else if (eingang > 0) cls = 'bg-blue-100 text-blue-800';
  else cls = 'bg-amber-100 text-amber-800';

  return (
    <span
      className={`inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded text-[10px] font-medium ${cls}`}
      title={
        isUeberfaellig
          ? `${summary.ueberfaellig} überfällig`
          : `${eingang} von ${total} eingegangen`
      }
    >
      <Package className="w-3 h-3" />
      {isUeberfaellig ? `${summary.ueberfaellig}!` : `${eingang}/${total}`}
    </span>
  );
}

// Hook für Bulk-Summary mit Caching pro Komponente
import { useState, useEffect } from 'react';
import { api, type BeistelteilModul } from '../lib/api';

export function useBeistelteileSummary(modul: BeistelteilModul, ids: number[]) {
  const [map, setMap] = useState<Record<string, BeistelteilSummary>>({});
  // Stable key from sorted ids to avoid unnecessary refetches
  const key = ids.slice().sort((a, b) => a - b).join(',');

  useEffect(() => {
    if (ids.length === 0) {
      setMap({});
      return;
    }
    let cancelled = false;
    api.beistelteile.summary(modul, ids)
      .then(res => {
        if (!cancelled) setMap(res.data);
      })
      .catch(() => {});
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modul, key]);

  return map;
}
